import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SmOverflowTooltipComponent} from './sm-overflow-tooltip.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SmOverflowTooltipComponent],
  exports: [SmOverflowTooltipComponent],
})
export class SmOverflowTooltipModule {}
